const routes = [
  {
    path: "/activities",
    component: () => import("@/views/app/pages/activities")
  }
];

export default routes;
